<template>
  <DataListStateful
    title="Поставки"
    resource="shippings"
    store="shippings"
    :columns="columns"
    :add-route="{ name: 'shipping-new-steps' }"
    :filter-options="filter"
    :row-color-fn="getShippingRowColor"
  />
</template>

<script>
import lables from "./components/labels/lables.js";
import { eShippingStates } from "./shipping-states.js";
import { shippingSources } from "./shipping-sources.js";
export default {
  data() {
    return {
      columns: [
        {
          title: "",
          name: "isHandledByAdmin",
          width: "32",
          type: "mark",
        },
        {
          title: "",
          name: "hasUnreadNotes",
          type: "icon",
          icon: "announcement",
          color: "green",
          tooltip: "Новый комментарий",
          sortable: false,
          visible: true,
        },
        {
          title: "Номер",
          name: "number",
          isEditLink: true,
          sortable: true,
          visible: true,
        },
        {
          title: "Запрос",
          name: "ShipmentRequest",
          dataPath: "ShipmentRequest.Title",
          sortable: true,
          visible: true,
        },
        {
          title: "Маршрут",
          name: "routeNumber",
          dataPath: "RouteNumber",
          sortable: false,
          tooltip: "Текущий маршрут",
          type: "tooltip",
          visible: true,
        },
        {
          title: "Контрагент",
          name: "counterparty",
          dataPath: "Counterparty.Title",
          sortable: false,
          visible: true,
        },
        {
          title: "Номер машины",
          name: "vehicle",
          sortable: false,
          visible: true,
        },
        {
          title: "Дата создания",
          name: "date",
          visible: true,
          width: "65",
          sortable: true,
          maxLength: 10,
        },
        {
          title: "Дата заезда к отправителю план",
          name: "dateOfExportFromFactoryPlan",
          dataPath: "DateOfExportFromFctoryPlan",
          type: "date",
          visible: true,
          width: "65",
          sortable: true,
          maxLength: 10,
        },
        {
          title: "Дата заезда к отправителю факт",
          name: "dateOfExportFromFactoryFact",
          dataPath: "DateOfExportFromFctoryFact",
          type: "date",
          visible: true,
          width: "65",
          sortable: true,
          maxLength: 10,
        },
        {
          title: "Автор заявки",
          name: "author",
          dataPath: "Author.Title",
          sortable: true,
        },
        {
          title: "Место создания",
          name: "sourceOfCreation",
          valueFn(item) {
            return shippingSources[item.Source];
          },
        },
        {
          title: "Пользователь кабинета",
          name: "authorContactPerson",
          dataPath: "AuthorContactPerson.Title",
          sortable: true,
        },
        {
          title: "Менеджер",
          name: "manager",
          dataPath: "Manager.Title",
          sortable: true,
        },
        {
          title: "Клиент",
          name: "client",
          dataPath: "Client.Title",
          sortable: true,
          width: "120",
          whiteSpace: true,
          maxLength: 20,
        },
        {
          title: "Клиент по документам",
          name: "clientAlias",
          sortable: true,
          width: "120",
          whiteSpace: true,
          maxLength: 20,
        },
        {
          title: "Внутренний номер заявки у клиента",
          name: "internalRequestNumber",
          dataPath: "InternalRequestNumber",
          sortable: true,
          width: "85",
        },
        {
          title: "Страна отправления",
          name: "country",
          dataPath: "Country.Title",
          visible: true,
          width: "85",
          maxLength: 8,
          sortable: true,
        },
        {
          title: "Направление",
          name: "direction",
          dataPath: "Direction.Title",
          visible: true,
          width: "85",
          maxLength: 8,
          sortable: true,
        },
        {
          title: "Регион",
          name: "region",
          dataPath: "Region.Title",
          sortable: false,
          width: "120",
          whiteSpace: true,
          maxLength: 20,
        },
        {
          title: "Область",
          name: "District",
          dataPath: "District.Title",
          sortable: false,
        },
        {
          title: "Индекс",
          name: "Postcode",
          sortable: false,
        },
        {
          title: "Продавец",
          name: "sender",
          valueFn(item) {
            return item.SenderFactory ? item.SenderFactory.Title : "";
          },
          sortable: true,
          width: "120",
          whiteSpace: true,
          maxLength: 20,
        },
        {
          title: "Производитель",
          name: "Manufacturer",
          type: "text-array",
          sortable: false,
          width: "120",
          whiteSpace: true,
          maxLength: 20,
        },
        {
          title: "Город выгрузки",
          name: "unloadingCity",
          dataPath: "UnloadingCity.Title",
          width: "80",
          sortable: true,
          maxLength: 10,
        },
        {
          title: "Рефренс погрузки",
          name: "loadingNumber",
          width: "120",
          sortable: true,
          whiteSpace: true,
          maxLength: 20,
          valueFn(item) {
            return item.LoadingNumber
              ? item.LoadingNumber.replace(/\n/g, "; ")
              : "";
          },
        },
        {
          title: "Категория товара",
          name: "productCategories",
          type: "text-array",
          sortable: false,
          width: "150",
          whiteSpace: true,
          maxLength: 20,
        },
        {
          title: "Стоимость партии груза",
          name: "invoiceSum",
          dataPath: "InvoiceSum",
          type: "int",
          scale: 2,
          sortable: true,
        },
        {
          title: "Валюта",
          name: "currency",
          dataPath: "Currency.Title",
          sortable: true,
        },
        {
          title: "Страна-получатель по докам фабрики/отправителя",
          name: "destinationCountry",
          dataPath: "DestinationCountry.Title",
          width: "175",
          sortable: false,
          maxLength: 10,
        },
        {
          title: "Страна",
          name: "unloadingCountry",
          dataPath: "UnloadingCountry.Title",
          sortable: true,
        },
        {
          title: "Дата готовности",
          name: "readyDate",
          visible: true,
          width: "65",
          sortable: true,
          maxLength: 10,
        },
        {
          title: "Желаемая дата доставки План",
          name: "desiredDeliveryDatePlan",
          visible: true,
          width: "65",
          sortable: true,
          maxLength: 10,
        },
        {
          title: "Желаемая дата доставки Заявка",
          name: "wantedDates",
          type: "dateRange",
          visible: true,
          width: "65",
          sortable: true,
          maxLength: 10,
        },
        {
          title: "Дата доставки план/факт",
          name: "deliveryDate",
          valueFn(value) {
            if (value.DeliveryToUnloadingPlaceDateFact) {
              return value.DeliveryToUnloadingPlaceDateFact;
            } else {
              return value.DeliveryToUnloadingPlaceDatePlan;
            }
          },
          visible: true,
          width: "75",
          sortable: true,
          maxLength: 10,
        },
        {
          title: "Объем, м3",
          name: "volume",
          dataPath: "Volume",
          type: "decimal",
          scale: 3,
          sortable: true,
        },
        {
          title: "Вес брутто, кг",
          name: "Weight",
          dataPath: "Weight",
          type: "decimal",
          scale: 3,
          sortable: true,
        },
        {
          title: "Тип поставки",
          name: "shippingType",
          dataPath: "ShippingType.Title",
          sortable: true,
          width: 140,
          whiteSpace: true,
        },
        {
          title: "Срочность",
          name: "urgency",
          dataPath: "Urgency.Title",
          sortable: true,
        },
        {
          title: "Мультимодальная",
          name: "multimodal",
          dataPath: "Multimodal",
          type: "bool",
          width: "75",
          sortable: true,
          maxLength: 10,
        },
        {
          title: "Invoice",
          name: "invoice",
          dataPath: "Invoice.Title",
          sortable: true,
        },
        {
          title: "EX",
          name: "ex",
          valueFn(item) {
            return `${
              lables.ex.value.exWhoDoing.variants.find(
                (i) => i.id === item.Ex.ExWhoDoing
              ).title
            } / ${
              item.Ex.ExDocumentInSystem ? "есть в системе" : "нет в системе"
            }`;
          },
          width: "120",
          sortable: false,
          whiteSpace: true,
          maxLength: 30,
        },
        {
          title: "Описание",
          name: "description",
          dataPath: "Description.Title",
          width: "140",
          sortable: true,
          whiteSpace: true,
        },
        {
          title: "Повреждения",
          name: "damage",
          dataPath: "Damage",
          type: "bool",
          width: "75",
          sortable: true,
          maxLength: 10,
        },
        {
          title: "Особое внимание",
          name: "attention",
          dataPath: "Attention",
          type: "bool",
          width: "75",
          sortable: true,
          maxLength: 10,
        },
        {
          title: "Негабарит",
          name: "oversized",
          dataPath: "Oversized",
          type: "bool",
          width: "75",
          sortable: true,
          maxLength: 10,
        },
        {
          title: "Хрупкий",
          name: "fragile",
          dataPath: "Fragile",
          type: "bool",
          width: "75",
          sortable: true,
          maxLength: 10,
        },
        {
          title: "Груз обмеряем?",
          name: "mesurable",
          dataPath: "Mesurable.Title",
          width: "75",
          sortable: true,
          maxLength: 10,
        },
        {
          title: "Груз можно отгружать?",
          name: "giveAway",
          dataPath: "GiveAway",
          type: "bool",
          width: "75",
          sortable: true,
          maxLength: 10,
        },
        {
          title: "Груз перепакован?",
          name: "cargoRepacked",
          dataPath: "CargoRepacked",
          type: "bool",
          width: "75",
          sortable: true,
          maxLength: 10,
        },
        {
          title: "Рекламация",
          name: "claim",
          dataPath: "Claim",
          type: "bool",
          width: "75",
          sortable: true,
          maxLength: 10,
        },
        {
          title: "Груз оплачен?",
          name: "isPayed",
          dataPath: "IsPayed",
          type: "bool",
          width: "75",
          sortable: true,
          maxLength: 10,
        },
        {
          title: "Нужна ли EX?",
          name: "needEx",
          dataPath: "NeedEx.Title",
          sortable: true,
        },
        {
          title: "Разобрать по ордерам",
          name: "parseByOrders",
          dataPath: "ParseByOrders",
          type: "bool",
          width: "75",
          sortable: true,
          maxLength: 10,
        },
        {
          title: "Статус поставки",
          name: "state",
          valueFn(item) {
            return item.State;
          },
          type: "object",
          sortable: true,
        },
        {
          title: "Склад погрузки",
          name: "loadingWarehouse",
          dataPath: "LoadingWarehouse.Title",
          width: "150",
          sortable: false,
          maxLength: 25,
        },
        {
          title: "Склад выгрузки",
          name: "unloadingWarehouse",
          dataPath: "UnloadingWarehouse.Title",
          width: "150",
          sortable: false,
          maxLength: 25,
        },
      ],
      filter: {
        number: {
          title: "Номер",
          type: "text",
        },
        route: {
          title: "Номер маршрута",
          type: "reference",
          resource: "routes",
        },
        date: {
          title: "Дата",
          type: "date",
          isManualEdit: true,
        },
        author: {
          title: "Автор заявки",
          type: "reference",
          resource: "users",
        },
        authorContactPerson: {
          title: "Пользователь кабинета",
          type: "reference",
          resource: "contact-persons",
          params: {
            hasCabinetUser: true,
          },
        },
        manager: {
          title: "Менеджер",
          type: "reference",
          resource: "employees",
        },
        client: {
          title: "Клиент",
          type: "reference",
          resource: "clients",
        },
        country: {
          title: "Страна отправления",
          type: "reference",
          resource: "countries",
        },
        region: {
          title: "Регион",
          type: "reference",
          resource: "regions",
        },
        factory: {
          title: "Продавец",
          type: "reference",
          resource: "factories",
        },
        unloadingCity: {
          title: "Город выгрузки",
          type: "reference",
          resource: "cities",
        },
        loadingNumber: {
          title: "Рефренс погрузки",
          type: "text",
        },
        invoiceSum: {
          title: "Стоимость партии груза",
          type: "int",
        },
        warehouse: {
          title: "Склад",
          type: "reference",
          resource: "warehouses",
        },
        loadingWarehouse: {
          title: "Склад погрузки",
          type: "reference",
          resource: "warehouses",
          emptyValue: true,
        },
        unloadingWarehouse: {
          title: "Склад выгрузки",
          type: "reference",
          resource: "warehouses",
          emptyValue: true,
        },
        destinationCountry: {
          title: "Страна",
          type: "reference",
          resource: "countries",
        },
        readyDate: {
          title: "Дата готовности",
          type: "date",
          isManualEdit: true,
        },
        deliveryDate: {
          title: "Дата доставки план/факт",
          type: "date",
          isManualEdit: true,
        },
        wantedDate: {
          title: "Желаемая дата доставки План",
          type: "date",
          isManualEdit: true,
        },
        volume: {
          title: "Объем",
          type: "decimal",
        },
        weightBrutto: {
          title: "Вес брутто",
          type: "decimal",
        },
        shippingTypes: {
          title: "Тип поставки",
          type: "enum",
          resource: "delivery-types",
        },
        isPayed: {
          title: "Груз оплачен?",
          type: "bool",
        },
        needEx: {
          title: "Нужна ли EX?",
          type: "enum",
          resource: "need-ex-types",
        },
        parseByOrders: {
          title: "Разобрать по ордерам",
          type: "bool",
        },
        states: {
          title: "Статус поставки",
          type: "enum",
          resource: "shipping-states",
        },
        hasUnreadNotes: {
          title: "Наличие новых сообщений",
          type: "bool",
        },
        district: {
          title: "Область",
          type: "reference",
          resource: "districts",
        },
        postcode: {
          title: "Индекс",
          type: "text",
        },
        dateOfExportFromFactoryPlan: {
          title: "Дата заезда к отправителю план",
          type: "date",
          isManualEdit: true,
        },
        dateOfExportFromFactoryFact: {
          title: "Дата заезда к отправителю факт",
          type: "date",
          isManualEdit: true,
        },
        invoice: {
          title: "Invoice в системе?",
          type: "bool",
        },
        exDocumentInSystem: {
          title: "ЕХ в системе?",
          type: "bool",
        },
        currency: {
          title: "Валюта",
          type: "reference",
          resource: "currencies",
        },
      },
    };
  },
  methods: {
    getShippingRowColor(shipping) {
      if (
        !shipping.hasPhases &&
        shipping.state.Id != eShippingStates.NotAccepted &&
        shipping.state.Id != eShippingStates.CanceledByClient
      ) {
        return "yellow lighten-4 ";
      } else if (
        (!shipping.hasPhases &&
          shipping.state.Id == eShippingStates.NotAccepted) ||
        (!shipping.hasPhases &&
          shipping.state.Id == eShippingStates.CanceledByClient)
      ) {
        return "grey--text";
      } else {
        return "";
      }
    },
  },
};
</script>

<style>
.handledByAdminMark {
  width: 8px;
  height: 8px;
  background-color: pink;
}
</style>
